import {Toast} from 'vant'


export const RegIphone = /iphone/i;

export const RegPhone = /^(0|86|17951)?(1)[0-9]{10}$/;

// export const IdCard = /(^\d{8}(0\d|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0\d|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/;
export const IdCard = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;

export function PhoneIsCheck(msg = '请输入正确的手机号码') {
    return {pattern: RegPhone, msg: msg}
}

export function Required(msg = '填写不能为空') {
    return {required: true, msg: msg}
}

export function Float2(msg = '只能填写数字并且最多两位小数') {
    return { pattern: /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/, msg: msg}
}

export function Float2Max100(msg = '只能填写数字并且最大数是100不能超个两位小数') {
    return { pattern: /^\d\.([1-9]{1,2}|[0-9][1-9])$|^[1-9]\d{0,1}(\.\d{1,2}){0,1}$|^100(\.0{1,2}){0,1}$/, msg: msg}
}

export function Url(msg = '请输入正确的链接地址') {
    return { pattern: /^https?:\/\//i , msg: msg}
}

export function IntMax99(msg = '只能填写1-99的整数') {
    return { pattern: /^[1-9][0-9]{0,1}$/ , msg: msg}
}

export function Number(msg = '只能填写数字') {
    return { pattern: /^[0-9]*$/ , msg: msg }
}

export function MaxAge(msg = '年龄不超过159岁') {
    return { pattern: /^((1[0-5])|[1-9])?\d$/ , msg: msg }
}


export function Validate(form = {},rules = {}) {
    for (let rulesKey in rules) {

        let ruleVal = rules[rulesKey];

        if(form.hasOwnProperty(rulesKey)){
            let formVal = form[rulesKey];
            for(let i =0;i<ruleVal.length;i++){
                let r = ruleVal[i];
                if(r.hasOwnProperty('required') && r['required']){

                    if(formVal.length == 0){
                        Toast(r.msg);
                        return false
                    }
                }
                if(r.hasOwnProperty('pattern') && formVal.length != 0){
                    if(Array.isArray(formVal)){
                        for(let i =0;i<formVal.length;i++){
                            if(!r.pattern.test(formVal[i])){
                                Toast(r.msg);
                                return false
                            }
                        }

                    }else {
                        if(!r.pattern.test(formVal)){
                            Toast(r.msg);
                            return false
                        }
                    }

                }
            }
        }
    }
    return true
}
